/**
 * @fileoverview Constants for Autodesk Forge Viewer.
 */

/** View type identifiers */
export const VIEW_TYPE = {
	THREE_D: "3D",
	TWO_D: "2D",
};

/** Viewer mode identifiers */
export const VIEWER_MODE = {
	LOCAL: "local",
	APS: "aps",
};

/** Forge viewer theme */
export const VIEWER_THEME = "dark-theme";

/** Translation status values from Autodesk API */
export const TRANSLATION_STATUS = {
	IN_PROGRESS: "inprogress",
	COMPLETED: "completed",
	SUCCESS: "success",
	PENDING: "pending",
};

/** Polling interval for translation status checks (ms) */
export const TRANSLATION_POLL_INTERVAL_MS = 5000;

/** Forge viewer extensions to load */
export const VIEWER_EXTENSIONS = ["Autodesk.AEC.LevelsExtension"];
